import axios from "../axiosInstance.js"
import { PUBLISHED_LIST_PARAMS } from "../queryDefaults.js"

const state = {
  news: [],
  selectedNewsArrayId: 0
}

const getters = {
  getNews: state => state.news,
  getSelectedNews: state => state.news[state.selectedNewsArrayId],
}

const actions = {
  fetchNews({
    commit
  }) {
    axios.get("/news", { params: PUBLISHED_LIST_PARAMS })
      .then(res => commit("setNews", res.data.docs))
      .catch(err => console.error(err))
  }
}

const mutations = {
  setNews: (state, news) => state.news = news,
  setSelectedNewsArrayId: (state, id) => state.selectedNewsArrayId = id
}

export default {
  state,
  getters,
  actions,
  mutations
}
